var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 50,
    viewBox: "0 0 36 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3064 0.018949L20.0371 48.2795L24.1995 48.9086L31.4687 0.648018L27.3064 0.018949Z",
    fill: "#071C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7058 25.265L9.25854 44.4824L12.5373 47.1268L27.9846 27.9094L24.7058 25.265Z",
    fill: "#071C5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3015 1.96721L14.3745 3.48584L32.0338 49.3042L35.9608 47.7855L18.3015 1.96721Z",
    fill: "#1459FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72712 9.18496L5.08716 12.4692L24.0745 27.7831L26.7145 24.4988L7.72712 9.18496Z",
    fill: "#071C5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.35088 21.3152L0.749756 25.4885L25.1576 29.016L25.7587 24.8427L1.35088 21.3152Z",
    fill: "#071C5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6722 24.1522L20.0371 48.2854L24.1995 48.9145L27.8345 24.7812L23.6722 24.1522Z",
    fill: "#071C5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8572 24.3209L4.07031 33.3074L5.61241 37.2308L28.3993 28.2443L26.8572 24.3209Z",
    fill: "#1459FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.819ef0ed72337cb9bd3a951813648d18.svg";
export { ForwardRef as ReactComponent };